// extracted by mini-css-extract-plugin
export default {"textPart":"emphasized_text-module___textPart___a9d94af3"};